import { css, styled } from '@mui/material';

export const SGrid = styled('div')(
  () => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 12px 8px;
  `,
);

export const SFeatureBlock = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 80px;
    padding: 16px 12px 16px 16px;
    border-radius: 12px;
    gap: 12px;
    background: ${theme.palette.grey[100]};
  `,
);
